import CurvedLineLong from "@/assets/curved_line_long.svg?react";
import { Problem } from "@/models/summary";

interface ProblemSummaryProps {
  referenceText: string;
  openVocView: (problem: string) => void;
  problem: Problem;
}

export const ProblemSummary: React.FC<ProblemSummaryProps> = ({
  referenceText,
  openVocView,
  problem,
}) => {
  return (
    <div className="mt-2 relative pl-7 overflow-hidden">
      <div className="absolute w-3 bottom-3 left-2.5">
        <CurvedLineLong className="w-full h-full" />
      </div>
      <p className="font-normal text-black leading-[1.8]">
        {problem.detail}
        <br />
        <button
          className="font-bold text-[#6788e1] underline cursor-pointer"
          onClick={() => openVocView(problem.title)}
        >
          {referenceText}
        </button>
      </p>
    </div>
  );
};
